import { render, staticRenderFns } from "./InvestorOnboardingReferalBanner.vue?vue&type=template&id=e0b53a9e&"
import script from "./InvestorOnboardingReferalBanner.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingReferalBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports